import { persistor } from "app/redux/store";
import { AuthRoles } from "configs/roles";
import { createContext } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import axiosPublic from "../../utils/axios-public";
import { removeCookies, setCookies } from "../../utils/cookies";
import { AESDecryptJSON } from "../../utils/encryption/AESDecrypt";

export const AuthContext = createContext({
    signIn: () => Promise.resolve(),
    signOut: () => {},
    signUp: () => Promise.resolve(),
    saveUserData: () => {},
});

export function AuthProvider({ children }) {
    const dispatch = useDispatch();
    const { authData } = useSelector(
        (state) => ({
            authData: state.AuthData,
        }),
        shallowEqual
    );

    const signIn = async (values) => {
        const response = await axiosPublic.post("/user/auth", {
            username: values.username,
            password: values.password,
        });
        setCookies(response);
        dispatch({
            type: "SIGN_IN",
            payload: response,
        });
        return response;
    };

    const signUp = async (values) => {
        const response = await axiosPublic.post("/user/add", {
            nama_lengkap: values.fullname,
            username: values.username,
            email: values.email,
            password: values.password,
            role: values.role,
            keterangan: values.description,
        });
        return response;
    };

    const signOut = () => {
        removeCookies();
        dispatch({ type: "SIGN_OUT" });
        persistor.purge();
    };

    const saveUserData = (response) => {
        dispatch({
            type: "SAVE_USER_DATA",
            payload: response,
        });
    };

    const decryptAuthData = AESDecryptJSON(authData.data);
    return (
        <AuthContext.Provider
            value={{
                isAuthenticated: authData.isAuthenticated,
                isInitialised: authData.isInitialised,
                isStrictAccess: AuthRoles.ROLES_OPERATOR.includes(
                    decryptAuthData?.role
                ),
                authData: decryptAuthData,
                signIn,
                signUp,
                signOut,
                saveUserData,
                // chgPassword,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}
